import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

interface ComicSectionProps {
  title: string;
  subtitle?: string;
  comics: Comic[];
  viewAllLink?: string;
  viewAllText?: string;
}

export default function ComicSection({ title, subtitle, comics, viewAllLink, viewAllText }: ComicSectionProps) {
  return (
    <section className="py-10 md:py-14">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-6 md:mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                {title}
              </h2>
              {subtitle && (
                <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
              )}
            </div>
            {viewAllLink && (
              <Link
                to={viewAllLink}
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
              >
                {viewAllText || '查看更多'}
                <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            )}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
            {comics.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}